import { createSlice } from "@reduxjs/toolkit";
import { Group } from "../../hooks/useFetchGroups";

const GroupSlice = createSlice({
    name: "group",
    initialState: {
       editGroupDetails: null,
       allGroups: [],
    },
    reducers: {  
        setGroupDetails: (state, action) => {
            state.editGroupDetails = action.payload;
        },
        setAllGroups: (state:any, action) => {
            state.allGroups = action.payload;
        },
    },
});

export default GroupSlice.reducer;
export const { setGroupDetails, setAllGroups } = GroupSlice.actions;
